import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'

export class Interval {
  lowerBound: number | undefined
  includeLowerBound: boolean
  upperBound: number | undefined
  includeUpperBound: boolean

  constructor() {
    this.lowerBound = undefined
    this.includeLowerBound = false
    this.upperBound = undefined
    this.includeUpperBound = false
  }
}

@Component({
  selector: 'jml-lib-interval-control',
  templateUrl: './interval-control.component.html',
  styleUrls: ['./interval-control.component.scss']
})
export class IntervalControlComponent implements OnInit {
  @Input() interval: Interval = new Interval()
  @Input() decimals: number | undefined = undefined
  @Output() formState = new EventEmitter<{ value: Interval; valid: boolean }>()
  intervalForm: FormGroup

  private fb = inject(FormBuilder)

  ngOnInit() {
    this.intervalForm = this.fb.group(
      {
        lowerBound: this.interval.lowerBound,
        includeLowerBound: this.interval.includeLowerBound,
        upperBound: this.interval.upperBound,
        includeUpperBound: this.interval.includeUpperBound
      },
      { validators: this.intervalValidator }
    )

    // Emit initial state
    this.emitFormState()

    // Subscribe to form changes and emit state
    this.intervalForm.valueChanges.subscribe(() => {
      this.emitFormState()
    })
  }

  emitFormState() {
    this.formState.emit({ value: this.intervalForm.value, valid: this.intervalForm.valid })
  }

  intervalValidator(formGroup: FormGroup) {
    const lowerBound = formGroup.get('lowerBound')?.value
    const upperBound = formGroup.get('upperBound')?.value
    const includeLowerBound = formGroup.get('includeLowerBound')?.value
    const includeUpperBound = formGroup.get('includeUpperBound')?.value

    const boundsDefined = lowerBound != undefined && upperBound != undefined
    const boundsUndefined = lowerBound == undefined && upperBound == undefined

    const invalidBoundaries =
      boundsDefined &&
      (lowerBound > upperBound || // if lowerBound is greater than upperBound => INVALID
        (lowerBound === upperBound && (!includeLowerBound || !includeUpperBound))) // if lowerBound equals upperBound but boundaries are not included --> INVALID

    // if a flag to include the boundary is set but the boundary is undefined => INVALID
    const invalidInclusion =
      (includeLowerBound && lowerBound === undefined) || (includeUpperBound && upperBound == undefined)

    if (boundsUndefined || invalidBoundaries || invalidInclusion) {
      return { intervalInvalid: true }
    }

    return null
  }
}
